import { render } from "./AnotacoesView.vue?vue&type=template&id=953f34e6&scoped=true&ts=true"
import script from "./AnotacoesView.vue?vue&type=script&lang=ts"
export * from "./AnotacoesView.vue?vue&type=script&lang=ts"

import "./AnotacoesView.vue?vue&type=style&index=0&id=953f34e6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953f34e6"]])

export default __exports__